import React from 'react';
import { useTranslation } from 'react-i18next';
import { SelectedItemsBar } from '@common/components';
import {
  DeleteIcon,
  PublishIcon,
  UnpublishIcon,
} from '@common/components/icons';

function SelectedReportsBar({
  numberOfSelectedReports,
  allReportsSelected = false,
  onDeselectAll,
  onPublish,
  onUnpublish,
  onDelete,
  // Default reports are read-only; when the selection includes one, all
  // mutating bulk actions are disabled with an explanatory tooltip.
  defaultSelected = false,
  disabledTooltip,
}) {
  const { t } = useTranslation();
  const tooltip = defaultSelected ? disabledTooltip : undefined;

  const actions = [
    {
      key: 'publish',
      icon: PublishIcon,
      text: t('reports.actions.publish'),
      onClick: onPublish,
      disabled: defaultSelected,
      title: tooltip,
    },
    {
      key: 'unpublish',
      icon: UnpublishIcon,
      text: t('reports.actions.unpublish'),
      onClick: onUnpublish,
      disabled: defaultSelected,
      title: tooltip,
    },
    {
      key: 'delete',
      icon: DeleteIcon,
      text: t('reports.actions.delete'),
      onClick: onDelete,
      disabled: defaultSelected,
      title: tooltip,
    },
  ];

  return (
    <SelectedItemsBar
      numberOfSelectedItems={numberOfSelectedReports}
      itemLabel={
        numberOfSelectedReports === 1
          ? t('reports.singular')
          : t('reports.plural')
      }
      allItemsSelected={allReportsSelected}
      onDeselectAll={onDeselectAll}
      actions={actions}
    />
  );
}

export default SelectedReportsBar;
